import { Component, OnInit, Input } from '@angular/core';
import { Brand } from 'app/shared/models/brand';
import { parseUniverseList } from 'app/shared/utils/universes';

@Component({
  selector: 'app-card-brand-details',
  templateUrl: './card-brand-details.component.html',
  styleUrls: ['./card-brand-details.component.sass']
})
export class CardBrandDetailsComponent implements OnInit {
  @Input() brand: Brand;

  isTermsOpen = false;

  constructor() { }

  ngOnInit() {}

  getUniverseList(universes) {
    return parseUniverseList(universes);
  }
}
